namespace GeniuzPOS.ReportMasterData {
    export interface Report_1414Form {
    }

    export class Report_1414Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1414';
    }
}
